export default __webpack_public_path__ + "static/media/placeholder-cat.907819f8.svg";